{
    "actions": {
        "page": {
            "dom_card": "Domiciliation card"
        },
        "row": {
            "update": "Update",
            "dom_card": "Domiciliation card"
        }
    },
    "filter": {
        "placeholder": {
            "legal_and_business_name": "Filter by merchants"
        }
    },
    "keys": {
        "legal_and_business_name": "Merchants"
    },
    "tooltip": {
        "legal_and_business_name": "You can search by merchant's social reason or commercial name"
    }
}